<template>
  <div>
    <footer class="sec-mt">
      <div class="container">
        <div class="row">
          <div class="col-md-2">
            <p class="logo">
              World Sports <br />
              Federation
            </p>
          </div>
          <div class="col-md-6">
            <ul>
              <li v-if="header[0] ? header[0].status : false">
                <router-link to="/accreditations">Accreditation</router-link>
              </li>
              <li v-if="header[8] ? header[8].status : false">
                <router-link to="/our-certificates">Certification</router-link>
              </li>
              <li v-if="header[1] ? header[1].status : false">
                <router-link to="/programs">Programs</router-link>
              </li>
              <li v-if="header[3] ? header[3].status : false">
                <router-link to="/about">About</router-link>
              </li>
              <li v-if="header[2] ? header[2].status : false">
                <router-link to="/memberships">Membership</router-link>
              </li>
              <li v-if="header[7] ? header[7].status : false">
                <router-link to="/online-trainings"
                  >Online Training</router-link
                >
              </li>
              <li v-if="header[4] ? header[4].status : false">
                <router-link to="/contact">Contact Us</router-link>
              </li>
              <li v-if="header[6] ? header[6].status : false">
                <router-link to="/events">Events &amp; Conferences</router-link>
              </li>
              <li>
                <router-link to="/privacy">Privacy</router-link>
              </li>

              <li v-for="(pg, idx) in pages" :key="idx">
                <router-link
                  :to="{ name: 'show-page', params: { slug: pg.slug } }"
                  :class="pg.has_footer ? '' : 'hidden'"
                >
                  {{ pg.title }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <div class="iaa-newsletter">
              <div class="bg-title mb-2">News</div>
              <div class="iaa-search mb-2 d-flex justigy-content-between">
                <input
                  v-model="email"
                  type="text"
                  placeholder="Your mail here"
                />
                <button @click="newsletter" class="subscribe-btn">
                  <div class="d-flex align-items-center">
                    Subscribe <span class="icon-arrow-right ml-2"></span>
                  </div>
                </button>
              </div>
              <div v-if="success" style="color: #080" class="alert-msg">
                email sent successfully.
              </div>
              <div v-if="error" style="color: #f00" class="alert-msg">
                this email not valid.
              </div>
            </div>
          </div>
        </div>
        <hr class="line" />
        <div class="actions">
          <div class="p-left">
            <li>2021 All Rights Reserved © WSF</li>
            <li>World Sports Federation</li>
          </div>
          <div class="p-right">
            <li>Follow Us</li>
            <!-- <li><i class="fa fa-facebook fa-lg"></i></li> -->

            <li>
              <a
                v-for="(social, index) in rows"
                class="social-icon"
                :href="social.provider_url"
                :key="index"
                target="_blank"
              >
                <i
                  v-if="social.provider.toLowerCase() == 'facebook'"
                  class="fab fa-facebook-f"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'youtube'"
                  class="fab fa-youtube"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'linkedin'"
                  class="fab fa-linkedin-in"
                ></i>
                <i
                  v-if="social.provider.toLowerCase() == 'twitter'"
                  class="fab fa-twitter"
                ></i>
              </a>
            </li>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.alert-msg {
  padding: 10px 0;
  font-size: 17px;
}
</style>

<style scoped>
.subscribe-btn:hover {
  background: #e7e6e6;
}
.subscribe-btn:active {
  opacity: 0.7;
}
.bg-title {
  font-size: 23px;
}
.iaa-search input {
  background: #fff;
  padding: 7px 15px;
  width: calc(100% - 120px) !important;
  border: 1px solid #d0d0d0 !important;
}
.subscribe-btn {
  border: 1px solid #d0d0d0 !important;
  background: #fff;
  color: #000;
  padding: 0 19px;
}
.icon-arrow-right {
  font-weight: bold;
  font-size: 17px;
}
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      header: [],
      pages: [],
      email: "",
      error: false,
      success: false,
    };
  },
  created() {
    axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => {});

    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
  },
  methods: {
    newsletter() {
      const options = {
        url: window.baseURL + "/newsletters",
        method: "POST",
        data: {
          email: this.email,
        },
      };

      axios(options)
        .then((res) => {
          console.log(res);
          this.email = "";
          this.success = true;
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.success = false;
          this.error = true;
        });
    },
  },
};
</script>
